import React from 'react';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';

const DashboardLayout = ({ children }) => {
  return (
    <div className="flex h-screen" style={{ backgroundColor: 'var(--bg-dark-pearl)' }}>
      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>
      
      {/* Mobile Navigation */}
      <MobileNav />
      
      {/* Main Content - Mobile optimized */}
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-7xl mx-auto px-4 py-6 md:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
